export const ADMIN_API_BASE_URL = import.meta.env['VITE_API_BASE_URL'] as string | undefined

// What the proof-of-possession audience is signed for - pinned, never
// inferred from the URL requests are sent to (see the API's
// docs/onboarding/reliability-m2m-oauth-onboarding.md). Only override alongside an API
// that itself runs with a different issuer.
export const AUTHORIZATION_SERVER_ISSUER =
  (import.meta.env['VITE_AUTHORIZATION_SERVER_ISSUER'] as string | undefined) ?? 'https://api.seewhocares.com'

/** Every client registers for the one product there is, so onboarding sends this rather than asking. */
export const APPLICATION_NAME = 'AutonoME'

/** Scopes an admin can grant at registration - see "Actors and auth" in AGENTS.md. */
export const GRANTABLE_SCOPES = [
  { scope: 'events:write', description: 'Post shift and worker events from their integration' },
  { scope: 'facilities:manage', description: 'Self-serve facilities, facility administrators and rosters' },
  { scope: 'rankings:read', description: 'Ask a facility to rank a pool of workers by reliability' },
  { scope: 'performance:read', description: "Generate, read and export performance summaries for the client's HR system (Performance Summaries add-on)" },
  { scope: 'census:write', description: "Record each unit's daily census from their EHR's ADT feed, which the staffing plan turns into seats" },
] as const
